package com.jingfangpai.content.model

import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.Content
import com.jingfangpai.common.orm.mapping.enums.ContentEntityType
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.contentEntity.model.ContentConnections
import kotlinx.serialization.Serializable

@Serializable
class ContentVo(): Content() {
    /* var id: String? = null

    *//** 类型  *//*
    var type: ContentType? = null

    *//** 主题  *//*
    var title: String? = null

    *//** 内容  *//*
    var content: String? = null

    *//** 所属对象Id  *//*
    var entityId: String? = null

    *//** 所属对象类型  *//*
    var entityType: ContentEntityType? = null

    *//** 排序  *//*
    var weight: Int? = null

    var index: String? = null*/

    var parent: ContentVo? = null

    var children: Array<ContentVo> = arrayOf()

    var comments: Set<Comment> = setOf()

    var connections = arrayOf<ContentConnections>()

    constructor(entity: Content) : this() {
        this.id = entity.id
        this.type = entity.type
        this.title = entity.title
        this.content = entity.content
        this.entityId = entity.entityId
        this.entityType = entity.entityType
        this.weight = entity.weight
        this.parent = null
        this.index = entity.index
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as ContentVo

        if (id != other.id) return false
        if (type != other.type) return false
        if (title != other.title) return false
        if (content != other.content) return false
        if (entityId != other.entityId) return false
        if (entityType != other.entityType) return false
        if (weight != other.weight) return false
        if (parent != other.parent) return false
        if (index != other.index) return false
        if (!children.contentEquals(other.children)) return false
        if (comments != other.comments) return false
        if (!connections.contentEquals(other.connections)) return false

        return true
    }

    override fun hashCode(): Int {
        var result = id?.hashCode() ?: 0
        result = 31 * result + (type?.hashCode() ?: 0)
        result = 31 * result + (title?.hashCode() ?: 0)
        result = 31 * result + (content?.hashCode() ?: 0)
        result = 31 * result + (entityId?.hashCode() ?: 0)
        result = 31 * result + (entityType?.hashCode() ?: 0)
        result = 31 * result + (weight ?: 0)
        result = 31 * result + (parent?.hashCode() ?: 0)
        result = 31 * result + (index?.hashCode() ?: 0)
        result = 31 * result + children.contentHashCode()
        result = 31 * result + comments.hashCode()
        result = 31 * result + connections.contentHashCode()
        return result
    }


}